import { Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { theme } from '../../../theme';
import { ThumbUpOutlined, ThumbDownOutlined } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import { useSendItemImageVoteMutation, useLogUserActionMutation } from '../../../api/physicianDashboardSlice';
import LogOnEnter from '../../CustomComponents/LogOnEnter';

function ImageContainer({ images }) {
    const [voteOnImage] = useSendItemImageVoteMutation();
    const [hasUserVoted, setHasUserVoted] = useState(images[0].has_user_voted);
    const [imageIndex, setImageIndex] = useState(0);
    const [logUserAction] = useLogUserActionMutation();

    const handleImageChange = (index) => {
        setImageIndex(index);
        setHasUserVoted(images[index].has_user_voted);
        logAction('viewed_item_image', { imageId: images[imageIndex].id });
    }

    const handleVoteResponse = async (vote) => {
        if (hasUserVoted) return;
        setHasUserVoted(true);
        await voteOnImage({ imageId: images[imageIndex].id, vote: vote });
    }

    async function logAction(action, data) {
        await logUserAction({
            action: action,
            data: data,
        });
    }

    return (
        <LogOnEnter action='viewed_item_image' data={{ imageId: images[imageIndex].id }}>
            <Stack spacing={2} p={2} sx={{ height: '100%', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                <Stack spacing={1}>
                    <Typography variant='heavy' sx={{ fontSize: '16px' }}>Images</Typography>
                    <Typography variant='normal' sx={{ fontSize: '12px', color: `${theme.palette.subtext.main}` }}>Swipe to see more images.</Typography>
                </Stack>
                <Carousel onChange={handleImageChange} showThumbs={false} showIndicators={false} showStatus={false} infiniteLoop={true} autoPlay={false}>
                    {images.map((image, index) => (
                        <div key={index}>
                            <img src={image.presigned_url} alt={`Index: ${index}`} />
                        </div>
                    ))}
                </Carousel>
                { hasUserVoted ? <Typography variant='normal' sx={{ fontSize: '12px' }}>Feedback recorded! Thank you!</Typography> :
                    <Stack direction='row' spacing={1} sx={{ fontSize: '12px', alignItems: 'center' }}>
                        <Typography variant='normal' sx={{ fontSize: '12px' }}>Was this image helpful?</Typography>
                        <IconButton color='primary' onClick={() => handleVoteResponse('upvote')} size='small'>
                            <ThumbUpOutlined />
                        </IconButton>
                        <IconButton color='primary' onClick={() => handleVoteResponse('downvote')} size='small'>
                            <ThumbDownOutlined />
                        </IconButton>
                    </Stack>
                }
            </Stack>
        </LogOnEnter>
    )
}

export default ImageContainer;
